import { MutableRefObject, useCallback, useEffect, useRef } from 'react';
import { isNil } from 'lodash';

const clearRefTimeout = (ref: MutableRefObject<NodeJS.Timeout | null>) => {
  if (!isNil(ref.current)) {
    clearTimeout(ref.current);
    ref.current = null;
  }
};

const useDelayedHover = (callback: () => void, delayMs = 100) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const mouseEnterHandler = useCallback(() => {
    clearRefTimeout(timeoutRef);
    timeoutRef.current = setTimeout(callback, delayMs);
  }, [callback, delayMs]);

  const mouseLeaveHandler = useCallback(() => {
    clearRefTimeout(timeoutRef);
  }, []);

  useEffect(() => () => clearRefTimeout(timeoutRef), []);

  return { mouseEnterHandler, mouseLeaveHandler };
};

export default useDelayedHover;
